export default __webpack_public_path__ + "static/media/berg.d3939f5a.webp";